export default {
    title: '{school} Khối {grade} Lớp {className} <span>({onlineCount}/{totalCount})</span>',
    onlineCount: 'Đang tham gia buổi học <span>({count} người)</span>',
    offlineCount: 'Chưa tham gia <span>({count} người)</span>',
    selectedStudents: 'Đã chọn {count} người',
    giveStar: ({ values }: { values: { isAll: boolean } }) => {
        const { isAll } = values;

        if (isAll) {
            return 'Tặng sao cho <span>tất cả học sinh</span>';
        }

        return '<span>Tặng sao</span>';
    },
    giveStarConfirm: 'Bạn có muốn tặng Sao khen thưởng cho <strong>{label}</strong> không?',
    comment: {
        '0': 'Giỏi lắm',
        '1': 'Tham gia rất tích cực',
        '2': 'Hợp tác tốt với bạn bè',
        '3': 'Giải thích rất tốt',
        '4': 'Trả lời rất logic',
        '5': 'Khả năng diễn đạt tuyệt vời',
        '6': 'Phát biểu rất tốt',
        '7': 'Câu trả lời rất sáng tạo',
        '8': 'Sáng tạo nổi bật',
    },
};
